import { Pipe, PipeTransform } from '@angular/core'


@Pipe({
  name: 'replace',
  pure: true
})
export class ReplacePipe implements PipeTransform {

  public transform(value: string, { target, replaceString }: { target: string, replaceString: string }): string {
    return value.replace(target, replaceString)
  }

}
